import React from 'react';
import Grid from '@material-ui/core/Grid';
import { When } from 'UI/components/atoms';
import FPHint from 'UI/components/atoms/FPHint';

import { useBulkFormFieldGridStyles } from './BulkFormFieldGrid.styles';

export const BulkFormFieldGrid = ({
  extraContent,
  label,
  hint,
  field,
  shouldShowField = false
}) => {
  const classes = useBulkFormFieldGridStyles({ shouldShowField });

  return (
    <Grid container direction="column" justifyContent="center" className={classes.root}>
      <Grid container item wrap="nowrap" alignItems="center" spacing={2}>
        <Grid
          container
          item
          xs={3}
          sm={2}
          wrap="nowrap"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item xs={11}>
            {label}
          </Grid>
          {hint && (
            <Grid item>
              <FPHint hint={hint} />
            </Grid>
          )}
        </Grid>
        <Grid item xs={9} sm={10}>
          {field}
        </Grid>
      </Grid>
      <When condition={extraContent && shouldShowField}>
        <Grid container item direction="row-reverse" justifyContent="flex-start">
          <Grid container item direction="row" xs={9} sm={10}>
            {extraContent}
          </Grid>
        </Grid>
      </When>
    </Grid>
  );
};
